import { Redirect, Route } from "react-router-dom"

const PrivateRoute = ({ component: Component, isAuthed, ...rest }) => {
  return <Route
    {...rest}
    render={(props) => (
      //check login
      isAuthed ?
        <>
          {/* <NavMenu {...props} /> */}
          {/* <LeftNavigation {...props} /> */}
          <Component {...props} />
        </> :
        <Redirect to='/login' {...rest} />
    )}
  />
};

export default PrivateRoute;